import { Phone } from "lucide-react";

interface SaintDisclaimerProps {
  /** Optional extra notice appended after the standard SAINT disclaimer. */
  extraNotice?: string;
}

/**
 * Required SAINT® safety / disclaimer block for the footer of every
 * SAINT page. Renders as a muted, small-print block.
 */
export const SaintDisclaimer: React.FC<SaintDisclaimerProps> = ({
  extraNotice,
}) => (
  <div className="border-t border-primary-foreground/15 mt-6 pt-5">
    <p className="text-xs leading-relaxed text-primary-foreground/55">
      SAINT® is FDA-cleared for adults with major depressive disorder who have
      not improved from prior antidepressant medications in the current episode.
      Not suitable for everyone, including people with certain implanted devices
      or non-removable magnetic-sensitive metal in or near the head. Possible
      effects include headache, fatigue, and treatment-site discomfort.
      Individual results vary. Educational information only, not medical advice.
      Insurance coverage for SAINT® is currently limited and varies by plan.
    </p>
    {extraNotice && (
      <p className="mt-3 text-xs leading-relaxed text-primary-foreground/55">
        {extraNotice}
      </p>
    )}
  </div>
);

export default SaintDisclaimer;
